// getNotificationData.js
'use strict';
import { Collection, Map } from 'immutable';
import createCachedSelector from '../resource/createCachedSelector.js';

const defaultMap = new Map();

/**
 * Select notification data by data key
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {KEY_TYPE} dataKey - select key.
 * @return {RETURN_TYPE} The selected notification data.
 */
const getNotificationData = createCachedSelector(
  (state, id) => state.getIn(['notifications', id]),
  (state, id, pathKey) =>
    Array.isArray(pathKey) ? pathKey : pathKey?.split('.'),
  (notification = defaultMap, joinKey) => {
    const result = notification.getIn(joinKey);
    return result instanceof Collection ? result.toJS() : result;
  }
)((state, id, dataKey) => `${id}:${dataKey}`);

export default getNotificationData;
